<template>
  <a-layout class="ai-assistant__wrapper">
    <a-layout-header>
      <div class="ai-assistant__header__main">
        <div class="ai-assistant__header__title">{{ userAgent && userAgent.agent_name || '--' }}</div>
        <a-space class="ai-assistant__header__info">
          <span>最后更新时间：{{ userAgent && userAgent.updated_at || '' }}</span>
        </a-space>
      </div>
      <a-space class="ai-assistant__header__actions">
        <!-- <a-tooltip title="日志">
          <a class="ai-assistant__header__action" @click.prevent>
            <a-icon type="book" />
          </a>
        </a-tooltip> -->
        <a-tooltip :title="fullscreen ? '还原' : '全屏'">
          <a class="ai-assistant__header__action" @click.prevent="triggerFullscreen">
            <a-icon :type="fullscreen ? 'fullscreen-exit' : 'fullscreen'" />
          </a>
        </a-tooltip>
      </a-space>
    </a-layout-header>
    <!-- 提示词列表 -->
    <a-layout-content ref="content">
      <!-- 简介 -->
      <div class="ai-assistant-intro">
        <div class="ai-assistant-intro__title">您好！我是{{ userAgent && userAgent.agent_name }}</div>
        <div class="ai-assistant-intro__desc">{{ userAgent && userAgent.agent_desc }}</div>
      </div>

      <div class="ai-assistant-chats">
        <div v-show="userAgent && userAgent.loading" class="ai-assistant-chat ai-assistant-chat--assistant">
          <div class="ai-assistant-chats__loading">
            <div class="ai-assistant-chats__loading-dot" />
            <div class="ai-assistant-chats__loading-dot" />
            <div class="ai-assistant-chats__loading-dot" />
          </div>
          <div class="ai-assistant-chat__content">思考中...</div>
        </div>
        <!-- <div v-show="inputValue.trim()" class="ai-assistant-chat ai-assistant-chat--user">
          <div class="ai-assistant-chat__content">{{ inputValue }}</div>
        </div> -->
        <!-- 问答列表 -->
        <div
          v-for="(message, index) in (userAgent && userAgent.chats || [])"
          :key="index"
          :class="{
            'ai-assistant-chat': true,
            'ai-assistant-chat--user': message.source === 1,
            'ai-assistant-chat--assistant': message.source === 2
          }"
        >
          <a-divider v-if="message.source === 3">清除上下文</a-divider>
          <div v-if="message.source !== 3" class="ai-assistant-chat__datetime">{{ message.created_at }}</div>
          <div v-if="message.source !== 3" class="ai-assistant-chat__content">
            <div v-if="message.think" class="ai-assistant-chat__think" v-html="message.think" />
            <div v-if="message.source === 1 || userAgent.agent_id === 2" class="ai-assistant-chat__html" v-html="message.content" />
            <div v-else-if="message.source === 2" class="ai-assistant-chat__markdown" v-html="message.markdown" />
          </div>
          <div v-if="message.source === 2" class="ai-assistant-chat__tools">
            <a-space>
              <a-tooltip title="复制">
                <a @click="copyText(message.content)">
                  <a-icon type="copy" />
                </a>
              </a-tooltip>
              <a-tooltip title="重新生成">
                <a @click="reSend(message)">
                  <a-icon type="redo" />
                </a>
              </a-tooltip>
            </a-space>
          </div>
        </div>
      </div>

      <!-- 提示词 -->
      <div v-if="userAgent && userAgent.chats && userAgent.chats.length && !userAgent.streaming && !userAgent.loading && userAgent.themes && userAgent.themes.length" class="ai-assistant-prompts-title">您可能想看</div>
      <a-space v-if="userAgent && !userAgent.streaming && !userAgent.loading" class="ai-assistant-prompts" direction="vertical" :size="12">
        <div
          v-for="(prompt, index) in (userAgent && userAgent.themes || [])"
          :key="index"
          class="ai-assistant-prompts__item"
          @click="selectPrompt(prompt)"
        >
          <div class="ai-assistant-prompts__title">{{ prompt.title }}</div>
          <a-icon type="arrow-right" />
        </div>
      </a-space>
    </a-layout-content>
    <a-layout-footer>
      <a-space style="margin-bottom: 10px;">
        <a-button type="default" @click="partition">清除上下文</a-button>
      </a-space>
      <div class="ai-assistant__textarea" ref="textarea">
        <a-input
          type="textarea"
          v-model="inputValue"
          :autosize="{ minRows: 6, maxRows: 8 }"
          :disabled="userAgent && (userAgent.streaming || userAgent.loading)"
          @keydown="handleSendMessage"
        />
        <a-button
          v-if="userAgent && !userAgent.streaming"
          class="ai-assistant__textarea__button"
          type="primary"
          :disabled="userAgent && userAgent.loading"
          @click="sendMessage"
        >
          发送
        </a-button>
        <a-button v-else class="ai-assistant__textarea__button" type="danger" @click="stopMessage">
          <i style="margin-right: 4px;display: inline-block;width: 11px;height: 11px;background-color: #fff;" />停止
        </a-button>
      </div>
      <div style="margin-top: 5px;margin-bottom: -5px;display: flex;align-items: center;">
        <span style="color: #0B1019;font-size: 12px;">剩余搜索量{{ quota && quota.daily_use_total || '0' }}/{{ quota && quota.daily_quota || '10' }}（限时免费，每日免费搜索量{{ quota && quota.daily_quota || '10' }}条）</span>
        <span style="color: #9199A7;font-size: 10px;">所有内容均由AI生成,仅供参考</span>
      </div>
    </a-layout-footer>
  </a-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AiAssistantChats',
  components: {
  },
  data () {
    return {
      loading: false,
      isDeepSeek: true,
      isNetwork: false,
      inputValue: '',
      isStreaming: false,
      abortController: null
    }
  },
  computed: {
    ...mapGetters('aiAssistant', [
      'userAgent',
      'user_agent_id',
      'quota',
      'fullscreen'
    ]),
    content () {
      return (this.user_agent_id && this.userAgent?.chats?.[0]?.content) || []
    }
  },
  methods: {
    triggerDeepSeek () {
      this.isDeepSeek = !this.isDeepSeek
    },
    triggerNetwork () {
      this.isNetwork = !this.isNetwork
    },
    handleSendMessage (e) {
      // 判断是否shift+enter
      if (e.shiftKey && e.keyCode === 13) {
      } else if (e.keyCode === 13) {
        e.preventDefault()
        this.sendMessage()
      }
    },
    getHistory () {
      // source: 1 用户 2 助手 3 清除上下文
      let history = this.userAgent.chats.map((item) => {
        if (item.source === 3) return undefined
        return item.source === 2
          ? { '问': item.content }
          : { '答': item.content }
      })

      // 获取最后一次清除上下文之后的历史对话
      if (history.some((item) => item === undefined)) {
        history = history.slice(0, history.lastIndexOf(undefined))
      }

      return history.reverse()
    },
    // 发送消息
    sendMessage () {
      if (this.userAgent.agent_id !== 2 && this.quota && this.quota.daily_use_total >= this.quota.daily_quota) {
        this.$message.warning('今日额度已达上限')
        return
      }

      if (!this.inputValue?.trim?.() && !this.loading) return

      this.loading = true
      this.$store.dispatch('aiAssistant/sendMessage', {
        method: 'robot',
        data: {
          agent_id: this.userAgent.agent_id,
          user_agent_id: this.userAgent.user_agent_id,
          message: this.inputValue.trim(),
          his_messages: this.getHistory()
        }
      }).then(() => {
        this.inputValue = ''
        this.loading = false
        this.scrollBottom()
      })
    },
    // 停止生成
    stopMessage () {
      this.$store.dispatch('aiAssistant/stopMessage')
    },
    // 开关全屏功能
    triggerFullscreen () {
      this.$store.dispatch('aiAssistant/triggerFullscreen')
    },
    // 点击提示词
    handlePromptClick (item) {
      this.inputValue = item.content
    },
    scrollBottom () {
      this.$nextTick(() => {
        const content = this.$refs.content && this.$refs.content.$el
        if (content) {
          content.scrollTop = content.scrollHeight
        }
      })
    },
    copyText (html) {
      // 创建临时DOM元素来解析HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html

      // 移除所有<think>标签
      const thinkElements = tempDiv.getElementsByTagName('think')
      while (thinkElements.length > 0) {
        thinkElements[0].parentNode.removeChild(thinkElements[0])
      }

      // 获取处理后的文本内容
      const textContent = tempDiv.textContent || tempDiv.innerText

      // 使用Clipboard API复制文本
      navigator.clipboard.writeText(textContent.trim())
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    getDetail () {
      if (!this.userAgent || !this.userAgent.user_agent_id) return
      this.$store.dispatch('aiAssistant/send', {
        method: 'getSessionDetail',
        data: {
          agent_id: this.userAgent.agent_id,
          user_agent_id: this.userAgent.user_agent_id
        }
      })

      setTimeout(() => {
        this.scrollBottom()
      }, 500)
    },
    reSend (message) {
      if (this.userAgent.agent_id !== 2 && this.quota && this.quota.daily_use_total >= this.quota.daily_quota) {
        this.$message.warning('今日额度已达上限')
        return
      }

      if (this.loading || this.userAgent.streaming || this.userAgent.loading) {
        this.$message.warning('请等待上一条消息生成完成')
        return
      }

      const index = this.userAgent.chats.findIndex((item) => item.message_id === message.message_id)

      if (index !== -1) {
        this.loading = true
        this.$store.dispatch('aiAssistant/sendMessage', {
          method: 'robot',
          data: {
            agent_id: this.userAgent.agent_id,
            user_agent_id: this.userAgent.user_agent_id,
            message: this.userAgent.chats[index + 1].content,
            his_messages: this.getHistory()
          }
        }).then(() => {
          this.loading = false
          this.scrollBottom()
        })
      }
    },
    partition () {
      if (this.loading || this.userAgent.streaming || this.userAgent.loading) {
        this.$message.warning('请等待上一条消息生成完成')
        return
      }

      this.$store.dispatch('aiAssistant/clearAgentPartition', this.user_agent_id)
    },
    focusTextarea () {
      const textarea = this.$refs.textarea
      if (textarea) {
        // 聚焦到子元素textarea
        const textareaChild = textarea.querySelector('textarea')
        if (textareaChild) {
          setTimeout(() => {
            // 聚焦到文本框
            textareaChild.focus()
            // 选中所有文本
            textareaChild.select()
            // 模拟点击事件
            textareaChild.click()
          }, 500)
        }
      }
    },
    init () {
      if (this.agent_id) return
      this.getDetail()
      this.focusTextarea()
    },
    selectPrompt (item) {
      this.loading = true
      this.$store.dispatch('aiAssistant/sendMessage', {
        method: 'robot',
        data: {
          agent_id: this.userAgent.agent_id,
          user_agent_id: this.userAgent.user_agent_id,
          message: item.prompt,
          his_messages: this.getHistory(),
          agent_theme_id: item.agent_theme_id
        }
      }).then(() => {
        this.loading = false
        this.scrollBottom()
      })
    }
  },
  watch: {
    user_agent_id: {
      handler: 'init'
    },
    content: {
      handler: 'scrollBottom',
      immediate: true
    },
    'userAgent.loading': {
      handler: 'focusTextarea'
    },
    'userAgent.streaming': {
      handler: 'focusTextarea'
    }
  },
  mounted () {
    this.getDetail()
  }
}
</script>

<style lang="less" scoped>
@import "./chats.less";
</style>
